var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function findPriceBracket(quantity, priceBrackets) {
    return priceBrackets.find(p => p.from <= quantity && (!p.to || p.to > quantity));
}
const CacheKey = 'physical-catalog';
export default class GmwPhysical {
    constructor(HoldingApi, HoldingUser, promiseCache, $q) {
        this.HoldingApi = HoldingApi;
        this.HoldingUser = HoldingUser;
        this.promiseCache = promiseCache;
        this.$q = $q;
        this.cart = [];
        this.countryCode = undefined;
    }
    selectCountry(countryCode) {
        this.countryCode = countryCode;
        this.clearCart();
    }
    clearCart() {
        this.cart = [];
    }
    unsetCountry() {
        this.countryCode = undefined;
        this.promiseCache.remove(CacheKey);
    }
    getCatalog() {
        if (!this.countryCode) {
            return this.$q.resolve([]);
        }
        return this.promiseCache({
            key: CacheKey,
            promise: () => this.HoldingApi.get('schiffgold/catalog', {
                params: { countryCode: this.countryCode },
            }).then(catalog => catalog.items),
            ttl: -1,
        });
    }
    getItemById(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const catalog = yield this.getCatalog();
            return catalog.find(item => item.id === id);
        });
    }
    addToCart(item, quantity) {
        const existingItem = this.cart.find(i => i.item === item);
        if (existingItem) {
            existingItem.quantity += quantity;
        }
        else {
            this.cart.push({ item, quantity });
        }
    }
    unitPrice(item, quantity) {
        const priceBracket = findPriceBracket(quantity, item.prices);
        if (!priceBracket) {
            return undefined;
        }
        return priceBracket.price;
    }
    quantityPrice(item, quantity) {
        const priceBracket = findPriceBracket(quantity, item.prices);
        if (!priceBracket) {
            return undefined;
        }
        return {
            amount: priceBracket.price.amount * quantity,
            currency: priceBracket.price.currency,
        };
    }
    subtotal() {
        const amount = this.cart.reduce((prev, curr) => {
            const lineTotal = this.quantityPrice(curr.item, curr.quantity);
            if (lineTotal) {
                return prev + lineTotal.amount;
            }
            return prev;
        }, 0);
        return { amount, currency: 'USD' };
    }
    getCountries() {
        return this.promiseCache({
            key: 'physical-countries',
            promise: () => this.HoldingApi.get('schiffgold/countries'),
            ttl: -1,
        });
    }
    validCart() {
        const goldWeight = this.cart
            .filter(i => i.item.metal === 'Gold')
            .reduce((prev, curr) => prev + curr.item.weightTOz * curr.quantity, 0);
        if (goldWeight >= 2) {
            return true;
        }
        const silverWeight = this.cart
            .filter(i => i.item.metal === 'Silver')
            .reduce((prev, curr) => prev + curr.item.weightTOz * curr.quantity, 0);
        if (silverWeight >= 20) {
            return true;
        }
        return false;
    }
    preview(address) {
        return this.HoldingApi.post('schiffgold/preview', {
            items: this.cart.map(i => ({ id: i.item.id, quantity: i.quantity })),
            address,
        });
    }
    confirm(id, address, metal, vault) {
        return this.HoldingApi.post('schiffgold/confirm', {
            items: this.cart.map(i => ({ id: i.item.id, quantity: i.quantity })),
            address,
            metal,
            id,
            split: 'Equal',
            vaults: [vault],
        });
    }
    purchase(id, address, metal, vault, pin) {
        return this.HoldingApi.post('schiffgold/purchase', {
            items: this.cart.map(i => ({ id: i.item.id, quantity: i.quantity })),
            address,
            metal,
            id,
            split: 'Equal',
            vaults: [vault],
            pin,
        });
    }
    remove(lineItem) {
        const index = this.cart.findIndex(l => l === lineItem);
        this.cart.splice(index, 1);
    }
    showRedeemBars() {
        return !this.HoldingUser.isHidden('redeemBars');
    }
}
GmwPhysical.$inject = ['HoldingApi', 'HoldingUser', 'promiseCache', '$q'];



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/physical/services/physical.ts